import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { acquireExecutionStream } from './executionStreamManager';

export function useExecutionStream(executionId: string | null | undefined) {
  const queryClient = useQueryClient();

  useEffect(() => {
    if (!executionId) return;
    const release = acquireExecutionStream(queryClient, executionId);
    return release;
  }, [executionId, queryClient]);
}
